export const NAME = 'companies';
